// =============================================================================
// Podgląd wydruku — druga zakładka prawej kolumny.
//
// PODGLĄD JEST OSOBNĄ ZAKŁADKĄ, NIE DOKLEJKĄ POD PŁÓTNEM. Wcześniej doklejał
// się pod płótnem, w tej samej przewijanej kolumnie: po pierwszym „Odśwież"
// płótno wyjeżdżało w górę, a użytkownik przewijał w tę i z powrotem między
// rzeczą, którą przesuwa, a rzeczą, na którą patrzy. Obie potrzebują całej
// wysokości okna i żadna nie może jej zabierać drugiej.
//
// To ten podgląd — nie płótno — mówi prawdę o wydruku: wraca z `…/podglad`,
// czyli z TEJ SAMEJ ścieżki renderu, którą pójdzie prawdziwe zadanie. Płótno
// obok jest widokiem do manipulacji i celowo nie udaje wierności.
// =============================================================================

import { Alert, Badge, Button, Select, Spinner } from '@insolitum/ui';
import { RefreshCw } from 'lucide-react';

export interface StanPodgladu {
  url: string | null;
  tekst: string | null;
}

export function PanelPodgladu({
  cele,
  cel,
  onCel,
  podglad,
  blad,
  pracuje,
  onOdswiez,
}: {
  cele: string[];
  cel: string;
  onCel: (c: string) => void;
  podglad: StanPodgladu | null;
  blad: string | null;
  pracuje: boolean;
  onOdswiez: () => void;
}) {
  return (
    <div className="flex h-full min-h-0 flex-col">
      <div className="flex items-center gap-2 border-b border-aurora-border p-2">
        <Select
          size="sm"
          value={cel}
          onChange={(e) => onCel(e.target.value)}
          options={cele.map((c) => ({ value: c, label: c }))}
        />
        <Button variant="secondary" size="sm" onClick={onOdswiez} loading={pracuje}>
          <RefreshCw className="h-3.5 w-3.5" />
          <span className="ml-1.5">Odśwież</span>
        </Button>
      </div>

      <div className="min-h-0 flex-1 overflow-auto p-3">
        {blad && <Alert variant="error">{blad}</Alert>}

        {!blad && !podglad && !pracuje && (
          <p className="text-xs text-aurora-subtle">
            Podgląd renderuje się tą samą ścieżką co prawdziwy wydruk — dlatego nie odświeża się sam
            przy każdym przesunięciu bloku. Kliknij „Odśwież", gdy chcesz zobaczyć, co wyjdzie z
            drukarki.
          </p>
        )}

        {pracuje && !podglad && (
          <div className="flex justify-center p-6">
            <Spinner />
          </div>
        )}

        {podglad && (
          <>
            <div className="mb-2 flex items-center gap-2 text-[11px] text-aurora-muted">
              Ta sama ścieżka renderu co wydruk
              <Badge>{cel}</Badge>
            </div>
            {podglad.url ? (
              <img
                src={podglad.url}
                alt="Podgląd wydruku"
                className="w-full border border-aurora-border bg-white"
              />
            ) : (
              <pre className="overflow-auto rounded bg-aurora-surface p-2 text-[10px] leading-relaxed text-aurora-text">
                {podglad.tekst}
              </pre>
            )}
          </>
        )}
      </div>
    </div>
  );
}
